import React, { useEffect, createElement } from 'react';
import { SalesPage } from './components/SalesPage';
import { PopupNotification } from './components/PopupNotification';
export function App() {
  useEffect(() => {
    // Meta Pixel Code
    const pixelId = '890245410416880';
    // @ts-ignore
    !function (f: any, b: any, e: any, v: any, n: any, t: any, s: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        document.head.appendChild(t);
      }
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    // @ts-ignore
    if (typeof (window as any).fbq === 'function') {
      ;
      (window as any).fbq('init', pixelId);
      (window as any).fbq('track', 'PageView');
    }
  }, []);
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-0">
      <SalesPage data-id="element-1" />
      <PopupNotification data-id="element-2" />
    </div>;
}